:host {
  display: inline-block;
}

:host [slot='control'] {
  --aha-button--padding-vertical: var(--spacer-1);
  --aha-button--padding-horizontal: var(--spacer-1);
  --aha-button--line-height: 0px;
}

:host aha-menu {
  height: inherit;
  width: inherit;
}

:host .pickable-color, aha-portal-outlet .pickable-color {
  width: 17px;
  height: 17px;
  border-radius: 2px;
}

:host .aha-color-picker__input-text {
  margin-bottom: 0;
}